import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { FormattedMessage } from 'react-intl';

import FacebookAdAuthButton from '../buttons/FacebookAdAuth';
import GoogleAdAuthButton from '../buttons/GoogleAdAuth';

import { BoxFlexCenterCenter } from '../customComponent/box';

import useUser from '../../hook/useUser';

import * as basicConstants from '../../constants/basic';
import * as urlConstants from '../../constants/url';

import { LinkCustom } from '../CustomComp';


const LoginMedia = (props) => {
  const { handleClose, handleSubmit, chooseMedia, mediaData } = props;
  const { userData } = useUser();

  return (
    <>
      <Typography variant="h3" align="center"><FormattedMessage id="account.modal.LogIn" /></Typography>
      <BoxFlexCenterCenter sx={{ maxWidth: '600px', margin: '40px 0 20px 0' }}>
        {
          mediaData.media === basicConstants.FACEBOOK &&
          <Box sx={{ mr: '20px' }}>
            <FacebookAdAuthButton handleSubmit={handleSubmit} />
          </Box>
        }
        {
          mediaData.media !== basicConstants.FACEBOOK &&
          <Box>
            <GoogleAdAuthButton
              handleSubmit={handleSubmit}
              media={mediaData.media}
            />
          </Box>
        }
      </BoxFlexCenterCenter>

      <Box sx={{ mt: '32px' }}>
        <LinkCustom to={urlConstants.PAGE_AD_ACCOUNTS}>
          <Button
            color="grey"
            sx={{
              marginLeft: 'auto', display: 'block'
            }}
          >
            <FormattedMessage id="common.button.cancel" />
          </Button>
        </LinkCustom>
      </Box>
    </>
  )
}

export default LoginMedia;